/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';

import AuthActions from 'auth/AuthActions';
import BoxBody from 'components/BoxBody.jsx';
import BoxFooter from 'components/BoxFooter.jsx';
import Button from 'components/Button.jsx';
import LoadingModal from 'components/LoadingModal.jsx';
import CurrentUser from 'auth/CurrentUser';
import Dialog from 'components/Dialog.jsx';
import GroupActions from 'groups/actions/GroupActions';
import GroupStore from 'groups/stores/GroupStore';
import JoinGroupAvatarPanel from 'join/components/JoinGroupAvatarPanel.jsx';
import Link from 'components/Link.jsx';
import Row from 'components/Row.jsx';
import ToastActions from 'actions/ToastActions';
import Group from 'entities/Group';

type Props = {
  code: string,
  onRequestHide: Function,
  onGroupNotFound?: Function,
};

type State = {
  group: ?Group,
};

class JoinConfirmSubscriptionModal extends React.Component<Props, State> {
  state: State = {
    group: null,
  };

  static defaultProps = {
    onRequestHide: () => undefined,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.loadGroup(this.props.code);
  }

  bypass = () => {
    this.context.router.push('/classes');
  };

  loadGroup = (code: string) => {
    const onNotFound = () => {
      ToastActions.showErrorToast('Group not found.');
      this.props.onRequestHide();

      if (this.props.onGroupNotFound) {
        this.props.onGroupNotFound();
      }
    };

    const onSuccess = (group: ?Group) => {
      if (!group) {
        onNotFound();
      } else if (GroupStore.isConnectedToGroup(group)) {
        ToastActions.showErrorToast('You have already joined this class.');
        this.props.onRequestHide();
      } else if (!group.canJoin()) {
        ToastActions.showErrorToast('Can’t join this class');
        this.props.onRequestHide();
      } else {
        this.setState({ group });
      }
    };
    GroupActions.searchGroupByCode(code).then(onSuccess, onNotFound);
  };

  signOutRequest = () => {
    AuthActions.signOut(`/join/${this.props.code}`);
  };

  subscribe = () => {
    const onSuccess = group => {
      ToastActions.showSuccessToast(`You’ve joined ${group.getName()}`);
      this.props.onRequestHide();
      this.context.router.push(`/classes/${group.getCodeOrError()}`);
    };
    const onError = error => {
      ToastActions.showErrorToast(error.message);
      this.props.onRequestHide();
    };
    GroupActions.subscribeToGroupWithCode(this.props.code).then(onSuccess, onError);
  };

  render() {
    if (!this.state.group) {
      return <LoadingModal />;
    }
    return (
      <Dialog
        {...this.props}
        size="xsmall"
        className="JoinConfirmSubscriptionModal"
        eventScreenName="JoinConfirmSubscriptionModal">
        <BoxBody>
          <Row>
            <JoinGroupAvatarPanel group={this.state.group} />
          </Row>
          <Button full onClick={this.subscribe} className="JoinConfirmSubscriptionModal-button">
            Join class
          </Button>
        </BoxBody>
        <BoxFooter>
          {`Logged in as ${CurrentUser.getUser().getSignature()}`}
          <br />
          Not you? <Link onClick={this.signOutRequest}>Log out</Link>
        </BoxFooter>
      </Dialog>
    );
  }
}

export default JoinConfirmSubscriptionModal;
